/** Resumo dos indicadores do ano na página inicial do gestor (Módulo 8). */
import { hojeEmBrasilia } from '@metaepi/shared';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router';
import { Cartao, CartaoTitulo, SeloStatus } from '../../components/ui';
import { useIndicadores } from './api';
import { formatarValor, TIPO_SELO } from './estado';

export function ResumoIndicadores() {
  const ano = Number(hojeEmBrasilia().slice(0, 4));
  const consulta = useIndicadores({ ano });
  const r = consulta.data;
  if (!r || r.precisaEscolherMunicipio) return null;
  return (
    <section aria-labelledby="titulo-resumo-indicadores" className="flex flex-col gap-3">
      <h2 id="titulo-resumo-indicadores" className="text-lg font-semibold text-texto">
        {`Indicadores de ${r.ano} · ${r.municipio.nome}/${r.municipio.uf}`}
      </h2>
      <Cartao className="flex flex-col gap-3">
        <CartaoTitulo className="sr-only">Resumo dos indicadores</CartaoTitulo>
        <ul className="flex flex-col gap-2">
          {r.indicadores
            .filter((i) => i.selo !== 'em_desenvolvimento')
            .map((i) => (
              <li
                key={i.codigo}
                className="flex flex-wrap items-center justify-between gap-2 text-sm"
              >
                <span className="text-texto">{i.descricao.titulo}</span>
                <span className="flex items-center gap-2">
                  <span className="font-semibold text-texto">
                    {formatarValor(i.valor, r.metas.valores[i.codigo])}
                  </span>
                  <SeloStatus tipo={TIPO_SELO[i.selo]}>{i.rotuloSelo}</SeloStatus>
                </span>
              </li>
            ))}
        </ul>
        <Link
          to="/indicadores"
          className="inline-flex items-center gap-1 self-start text-sm font-medium text-primaria hover:underline"
        >
          Ver os indicadores
          <ArrowRight className="size-4" aria-hidden="true" />
        </Link>
      </Cartao>
    </section>
  );
}
